import { Box, styled, StyleSystemProps } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { animationTransition } from '@shared/utils/animationTransition';

export const StyledHed = styled(Box)``;
export const StyledCta = styled(Box)``;
export const StyledCtaArrowButton = styled(Box)``;
export const StyledContainer = styled(Box)``;

const hedStyles: StyleSystemProps = {
  typographyVariant: ['hed4', null, 'display1'],
  fontWeight: [600, null, 600],
  cursor: 'pointer',
  transition: animationTransition('color'),
  _hover: {
    color: 'mono12',
  },
  _active: {
    color: '#000000',
  },
  // fontSize: [26, null, 32],
  // maxWidth: ['254px', null, 'fit-content']
};

const hedSpotlightStyles: StyleSystemProps = {
  ...hedStyles,
  color: 'white',
  _hover: {
    color: 'mono4',
  },
  _active: {
    color: 'white',
  },
};

const ctaStyles: StyleSystemProps = {
  height: '100%',
  typographyVariant: 'body2',
  fontWeight: 'semibold',
  textDecoration: 'underline',
  cursor: 'pointer',
  color: 'mono14',
  _hover: {
    color: 'mono12',
  },
  _active: {
    color: '#000000',
  },
};

const ctaSpotlightStyles: StyleSystemProps = {
  ...ctaStyles,
  color: 'white',
  _hover: {
    color: 'mono4',
  },
  _active: {
    color: 'white',
  },
};

const ctaArrowButtonStyles: StyleSystemProps = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
};

const carouselContainerStyles: CSSObject = {
  button: {
    display: 'none',
  },
};

export const styles = {
  hed: hedStyles,
  hedSpotlight: hedSpotlightStyles,
  cta: ctaStyles,
  ctaSpotlight: ctaSpotlightStyles,
  ctaArrowButton: ctaArrowButtonStyles,
  carouselContainer: carouselContainerStyles,
};
